module.exports = __webpack_public_path__ + "img/vz-styling-icons-email-copy.c7212c89.svg";